import { NumericFormat, PatternFormat } from "react-number-format";
import { CONFIG } from "../environment";
import { store } from "../store";

export function emailAddressMask(myemailId = "") {
  var maskid = "";
  if (myemailId !== null && myemailId !== undefined) {
    var prefix = myemailId.substring(0, myemailId.lastIndexOf("@"));
    var postfix = myemailId.substring(myemailId.lastIndexOf("@"));

    for (var i = 0; i < prefix.length; i++) {
      if (i === 0 || i === prefix.length - 1) {
        ////////
        maskid = maskid + prefix[i].toString();
      } else {
        maskid = maskid + "x";
      }
    }
    maskid = maskid + postfix;
  }
  return maskid;
}

export function mask(input) {
  if (
    input === undefined ||
    input === null ||
    input === "undefined" ||
    input === "null"
  ) {
    return "";
  }
  return (
    input.slice(0, input.length - 4).replace(/([a-zA-Z0-9])/g, "x") +
    input.slice(-4)
  );
}
export function maskPAN(input) {
  if (
    input === undefined ||
    input === null ||
    input === "undefined" ||
    input === "null"
  ) {
    return "";
  }
  return input.replace(/([a-zA-Z])/g, "x");
}

export function accNoFormat(account = {}) {
  return (
    <span>
      {account?.accountType} {account?.accountNo}
    </span>
  );
}

export function amountFormat(amount = "", currency = CONFIG.CURRENCY) {
  return (
    <NumericFormat
      displayType="text"
      value={amount}
      thousandSeparator={true}
      renderText={(formattedValue) => {
        const decimalIndex = formattedValue.indexOf(".");
        const hasDecimal = decimalIndex !== -1;
        const displayValue = hasDecimal
          ? formattedValue
          : `${formattedValue}.00`;
        const [integerPart, decimalPart] = displayValue.split(".");
        return (
          <>
            <div style={{ display: "inline",marginRight:4 }}>{currency}</div>
            <div style={{ display: "ruby", paddingLeft: 2 }}>
              {integerPart}
              <span style={{ fontSize: "11px" }}>.{decimalPart}</span>
            </div>
          </>
        );
      }}
    />
  );
}

export function amountNoCurrencyFormat(amount = "") {
  return (
    <NumericFormat
      displayType="text"
      value={amount}
      thousandSeparator={true}
      //
      decimalScale={2}
      fixedDecimalScale={true}
      renderText={(value) => {
        const [beforeDecimal, afterDecimal] = value.split(".");
        return (
          <>
            <div style={{ display: "inline" }}>{beforeDecimal}</div>
            <div style={{ display: "inline", fontSize: "11px" }}>
              .{afterDecimal}
            </div>
          </>
        );
      }}
    />
  );
}

export function amountExchangeCurrencyFormat(amount = "") {
  const formattedAmount = formatAmount(amount);

  return (
    <NumericFormat
      displayType="text"
      value={formattedAmount.beforeDecimal}
      thousandSeparator={true}
      renderText={(value) => (
        <>
          <div style={{ display: "inline" }}>{value}</div>
          <div style={{ display: "inline", fontSize: "11px" }}>
            {formattedAmount.decimalPart}
          </div>
        </>
      )}
    />
  );
}
function formatAmount(value) {
  const parts = value.split(".");
  const beforeDecimal = parts[0];
  const decimalPart = parts[1] ? `.${parts[1]}` : ".00";

  return {
    beforeDecimal,
    decimalPart,
  };
}

export const allowOnlyAlphaNumerics = async (e) => {
  const regex = new RegExp("[a-zA-Z0-9]");
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowOnlyAlphabets = async (e) => {
  const regex = new RegExp("[a-zA-Z]");
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowOnlyNumbers = async (e) => {
  const regex = new RegExp("[0-9]");
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowOnlyNumbersfrom1 = async (e) => {
  const regex = new RegExp("^[1-9][0-9]*$");
  const pressedKey = String.fromCharCode(e.charCode || e.which);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowOnlyNumbersWithoutLeadingZeros = async (e) => {
  const regex = new RegExp("[1-9][0-9]{0,1}|100000");
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowOnlyAlphaNumericsWithSpace = async (e) => {
  const regex = new RegExp(/^[a-zA-Z0-9\d\s]+$/i);
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowOnlyAlphabetsWithSpace = async (e) => {
  const regex = new RegExp(/^[a-zA-Z ]*$/);
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowOnlyAlphaNumericsWithSpaceAndComma = (e) => {
  const regex = new RegExp(/^[a-zA-Z0-9\d\s,]+$/i);
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowOnlyNumberswithMaxLimit = (e, maxLimit) => {
  const regex = new RegExp("[0-9]");
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (pressedKey === "." || !regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
  const inputValue = e.target.value.replace(/[^0-9]/g, "");
  const newValue = parseFloat(inputValue + pressedKey);
  if (!isNaN(newValue) && newValue > maxLimit) {
    e.preventDefault();
    return false;
  }
  const newInputValue = parseFloat(pressedKey + inputValue);
  if (!isNaN(newInputValue) && newInputValue > maxLimit) {
    e.preventDefault();
    return false;
  }
};

export const allowDecimalwithMaxLimit = (e, maxLimit) => {
  const regex = new RegExp("[0-9.]");
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
  const inputValue = e.target.value;
  const newValue = parseFloat(inputValue + pressedKey);
  if (!isNaN(newValue) && newValue > maxLimit) {
    e.preventDefault();
    return false;
  }
};

export const maskAccountNumber = (accountNo) => {
  const maskedPart = accountNo?.slice(0, -4).replace(/\d/g, "X");
  const lastFourDigits = accountNo?.slice(-4);
  const formattedMaskedPart = maskedPart?.replace(/(.{4})/g, "$1 ");
  return `${formattedMaskedPart}${lastFourDigits}`;
};

export const allowOnlyAlphaNumericsWithSpecialChar = (e) => {
  const regex = new RegExp(/^[a-zA-Z0-9._-]+$/i);
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const handlePasteNotAllowSpace = (e) => {
  const clipboardData = e.clipboardData || window.Clipboard;
  const pastedText = clipboardData.getData("text");
  const sanitizedText = pastedText.replace(/\s/g, "");
  document.execCommand("insertText", false, sanitizedText);
  e.preventDefault();
};

export const allowOnlyPressesNumbersWithMaxLimit = (e, maxLimit) => {
  const regex = new RegExp("[0-9]");
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  if (pressedKey === "." || !regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
  const inputValue = e.target.value.replace(/[^0-9]/g, "");
  const newValue = parseFloat(inputValue + pressedKey);
  if (!isNaN(newValue) && newValue > maxLimit) {
    e.preventDefault();
    return false;
  }
};

export function maskAmountFormat(currency = CONFIG.CURRENCY) {
  return (
    <>
      <div style={{ display: "inline" }}>{currency}</div>
      <div style={{ display: "ruby", paddingLeft: 2 }}>********</div>
    </>
  );
}

export const allowOnlyAlphabetsShouldNotStartWithSpace = async (e) => {
  const regex = new RegExp(/^[a-zA-Z ]*$/);
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  const currentValue = e.target.value;
  if (pressedKey === " " && (currentValue === "" || currentValue[0] === " ")) {
    e.preventDefault();
    return false;
  }
    if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowOnlyAlphaNumericsShouldNotStartWithSpace = async (e) => {
  const regex = new RegExp(/^[a-zA-Z0-9\d\s]+$/i);
  const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
  const currentValue = e.target.value;
  if (pressedKey === " " && (currentValue === "" || currentValue[0] === " ")) {
    e.preventDefault();
    return false;
  }
    if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};

export const allowAlphaNumericsWithSpecialCharactersAndSpace = (e) => {
  const regex = /^[a-zA-Z0-9!@#$%^&*().,<>{}\[\]<>?_=+\-|;:'"\/\s]$/;

  const pressedKey = e.key;
  if (!regex.test(pressedKey)) {
    e.preventDefault();
    return false;
  }
};